// @flow

import type { Attempt } from "./api/attempts";
import { sortBy } from "lodash";

export default function sortAttempts(attempts: Attempt[]): Attempt[] {
  return sortBy(attempts, a => a.created_at * -1);
}
